import axios, { AxiosResponse, AxiosError } from 'axios'

import auth from '@/api/resources/auth'
import cases from '@/api/resources/cases'
import creditors from '@/api/resources/creditors'
import files from '@/api/resources/files'
import sources from '@/api/resources/sources'
import tags from '@/api/resources/tags'

import * as T from '@/types'

////////////////////////////////////////////////////////////////
// public download API instance
////////////////////////////////////////////////////////////////

const headerlessApi: any = axios.create()

headerlessApi.interceptors.response.use(
    (response: AxiosResponse) => {
        return response
    },
    (error: AxiosError) => {
        const response = error.response
        console.log('DOWNLOAD ERROR', error)
        console.log('DOWNLOAD ERROR RESPONSE', response)
        throw error
    },
)

export default function (api: T.CreditorDeskApi) {
    api.auth = auth(api)
    api.cases = cases(api)
    api.creditors = creditors(api)
    api.files = files(api, headerlessApi)
    api.sources = sources(api)
    api.tags = tags(api)
}


